import { useOnline } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useAppStore = defineStore('app', () => {
  const hasNetworkError = ref(false)
  const isOnline = process.client ? useOnline() : ref(true)

  // Combined network status that checks both fetch errors and online status
  const hasAnyNetworkError = computed(
    () => hasNetworkError.value || (process.client && !isOnline.value),
  )

  function setNetworkError(value: boolean) {
    hasNetworkError.value = value
  }

  return {
    hasNetworkError,
    isOnline,
    hasAnyNetworkError,
    setNetworkError,
  }
})
